import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavigationHeader from "@/components/NavigationHeader";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import { SettingsProvider } from "@/context/SettingsContext";

export default function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <SettingsProvider>
      <div className="min-h-screen flex flex-col bg-white">
        <NavigationHeader />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </SettingsProvider>
  );
}
